import { render, staticRenderFns } from "./ListPanel.vue?vue&type=template&id=dfa20a28&scoped=true&"
import script from "./ListPanel.vue?vue&type=script&lang=js&"
export * from "./ListPanel.vue?vue&type=script&lang=js&"
import style0 from "./ListPanel.vue?vue&type=style&index=0&id=dfa20a28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa20a28",
  null
  
)

export default component.exports